import React from "react";
import {AdminReportList} from "../Report/AdminReportList";

export const CoordinatorDashboard : React.FC = () => {
    return (
        <AdminReportList restrictedReports/>
    )
}
